import React, { PureComponent } from "react";
import { connect } from "react-redux";
import * as accountActions from "../../../bookmakersSwitcher/accountPage/accountPage.actions";
import * as drawerActions from "../../../drawer/drawer.actions";
import { actions as bookmakersInfoActions } from "../../../common/bookmakersInfo";
import { clearExternalAccountData } from "../../../common/externalAccount/externalAccount.actions";
import "./styles.scss";
import BookmakersListHeader from "./BookmakersListHeader";
import BookmakersListItem from "./BookmakersListItem";

export class BookmakersList extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			activeBookmakerOfferIndex: null,
		};
	}

	toggleBookmakerOffer = (bookmakerIndex) => {
		this.setState({
			activeBookmakerOfferIndex: bookmakerIndex,
		});
	};

	componentWillUnmount = () => {
		this.props.clearExternalBetHistoryData();
		this.props.clearExternalAccountData();
	};

	render() {
		const {
			bookmakers,
			onSelect,
			selectedBookmaker,
			requestLogout,
			toggleBalanceVisibility,
			onHistoryChanged,
			selectedBookmakerFeed,
			loggedInBookmakersList,
			addAccountBookmakersList,
			externalBetHistoryUrl,
			isExternalBetHistoryError,
			getExternalBetHistoryUrl,
			clearSelectedBets,
			clearMultiples,
			resetEmptyBetslip,
			selectedBets,
		} = this.props;
		return (
			<div
				className='js-bs-bookmakersPage'
				data-test-selector='Container__BookmakersPageList'
			>
				<section className='root'>
					<BookmakersListHeader
						bookmakers={bookmakers}
						loggedInBookmakersList={loggedInBookmakersList}
						onSelect={onSelect}
						selectedBookmaker={selectedBookmaker}
					/>
					<div className='root__bookmakersContent root__rnCanvas'>
						{loggedInBookmakersList.length > 0 && (
							<span className='root__bookmakersPageText'>my bookmakers</span>
						)}
						<div
							className='root__bookmakersContentAccountLoggedIn'
							data-test-selector='Container__LoggedInBookmakers'
						>
							{loggedInBookmakersList.map((bookmaker, index) => (
								<BookmakersListItem
									key={bookmaker.feed}
									bookmakerIndex={index}
									isLoggedIn
									checked={selectedBookmaker === bookmaker.feed}
									toggleBalanceVisibility={toggleBalanceVisibility}
									requestLogout={requestLogout}
									bookmaker={bookmaker} // not used
									apiName={bookmaker.apiName}
									feed={bookmaker.feed}
									analyticsName={bookmaker.analyticsName}
									name={bookmaker.name}
									onHistoryChanged={onHistoryChanged}
									bookmakersList={bookmakers}
									selectedBookmakerFeed={selectedBookmakerFeed}
									registrationOffer={bookmaker.registrationOffer}
									registrationLink={bookmaker.registrationLink}
									registrationOfferLinkUrl={bookmaker.registrationOfferLinkUrl}
									registrationOfferHeadline={bookmaker.registrationOfferHeadline}
									registrationOfferLinkText={bookmaker.registrationOfferLinkText}
									registrationOfferDetailsLink={
										bookmaker.registrationOfferDetailsLink
									}
									userInfo={bookmaker.userInfo}
									withdrawBookmakerUrl={bookmaker.withdrawBookmakerUrl}
									isExternalLogout={bookmaker.isExternalLogout}
									externalBetHistoryUrl={externalBetHistoryUrl}
									isExternalBetHistoryError={isExternalBetHistoryError}
									getExternalBetHistoryUrl={getExternalBetHistoryUrl}
									clearSelectedBets={clearSelectedBets}
									clearMultiples={clearMultiples}
									resetEmptyBetslip={resetEmptyBetslip}
									selectedBets={selectedBets}
								/>
							))}
						</div>
					</div>
					<div className='root__bookmakersContent root__rnCanvas'>
						<span
							className='root__bookmakersPageText'
							data-test-selector='Text__AddBookmakerAccount'
						>
							add bookmaker account
						</span>
						<div
							className='root__bookmakersContentAccount'
							data-test-selector='Container__NonLoggedInBookmakers'
						>
							{addAccountBookmakersList.map((bookmaker, index) => {
								if (bookmaker.shouldNotRender) {
									return null;
								}
								return (
									<BookmakersListItem
										key={bookmaker.feed}
										bookmakerIndex={index}
										isLoginLeftPositioned={index % 2 === 1 && index !== 0}
										checked={selectedBookmaker === bookmaker.feed}
										toggleBalanceVisibility={toggleBalanceVisibility}
										requestLogout={requestLogout}
										bookmaker={bookmaker}
										apiName={bookmaker.apiName}
										feed={bookmaker.feed}
										analyticsName={bookmaker.analyticsName}
										name={bookmaker.name}
										onHistoryChanged={onHistoryChanged}
										bookmakersList={bookmakers}
										selectedBookmakerFeed={selectedBookmakerFeed}
										registrationOffer={bookmaker.registrationOffer}
										registrationLink={bookmaker.registrationLink}
										registrationOfferLinkUrl={
											bookmaker.registrationOfferLinkUrl
										}
										registrationOfferHeadline={
											bookmaker.registrationOfferHeadline
										}
										registrationOfferLinkText={
											bookmaker.registrationOfferLinkText
										}
										registrationOfferDetailsLink={
											bookmaker.registrationOfferDetailsLink
										}
										userInfo={bookmaker.userInfo}
										isWindowLogin={bookmaker.loginType === "window"}
										activeBookmakerOfferIndex={
											this.state.activeBookmakerOfferIndex
										}
										toggleBookmakerOffer={this.toggleBookmakerOffer}
									/>
								);
							})}
						</div>
					</div>
				</section>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		bookmakersSwitcher: {
			accountPage: { externalBetHistoryUrl, isExternalBetHistoryError },
		},
		bookmakersList,
		bookmakersInfo: { selectedBets },
	} = state;

	const filteredBySections = bookmakersList.reduce(
		(list, bookmakerInfo) => {
			if (
				bookmakerInfo.hasOwnProperty("userInfo") &&
				bookmakerInfo.isLoggedIn &&
				!bookmakerInfo.userInfo.error
			) {
				return {
					...list,
					loggedIn: [...list.loggedIn, bookmakerInfo],
				};
			}

			return {
				...list,
				addAccount: [...list.addAccount, bookmakerInfo],
			};
		},
		{ loggedIn: [], addAccount: [] }
	);

	return {
		loggedInBookmakersList: filteredBySections.loggedIn,
		addAccountBookmakersList: filteredBySections.addAccount,
		externalBetHistoryUrl,
		isExternalBetHistoryError,
		selectedBets,
	};
};

const mapDispatchToProps = {
	getExternalBetHistoryUrl: accountActions.getExternalBetHistoryUrl,
	clearExternalBetHistoryData: accountActions.clearExternalBetHistoryData,
	clearExternalAccountData,
	clearSelectedBets: bookmakersInfoActions.clearSelectedBets,
	clearMultiples: bookmakersInfoActions.clearMultiples,
	resetEmptyBetslip: drawerActions.resetEmptyBetslip,
};

export default connect(mapStateToProps, mapDispatchToProps)(BookmakersList);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/components/BookmakersList.jsx